<template>
  <div class="menu is-right" :class="{ 'is-open': isOpen }">
    <div class="menu-overlay" @click.self="close">
      <div class="menu-content-wrapper">
        <div class="menu-content" ref="scrollArea">
          <header class="menu-header">
            <div class="menu-header-title">
              <p class="text-break">アイテムのロック</p>
            </div>
          </header>
          <ul class="menu-link-list">
            <li class="menu-link-item">
              <label for="category-lock-all" class="checkbox">
                <input
                  id="category-lock-all"
                  type="checkbox"
                  v-model="all"
                  @change="onAllToggle"
                />
                <span class="checkbox-text">全て選択</span>
              </label>
            </li>
          </ul>
          <ul class="menu-link-list">
            <li
              v-for="category in categories"
              :key="category.category_id"
              class="menu-link-item"
            >
              <label :for="`category-${category.category_id}`" class="checkbox">
                <input
                  :id="`category-${category.category_id}`"
                  type="checkbox"
                  :value="category.category_id"
                  v-model="checks"
                  @change="onToggle"
                />
                <span class="checkbox-text" v-html="category.category_name"></span>
              </label>
            </li>
          </ul>
          <footer class="menu-footer">
            <div class="text-center">
              <WaveButton @click="save" :loading="loading">
                適用する
              </WaveButton>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/category'
import { renderError } from '@/utils/error'

export default {
  data() {
    return {
      checks: [],
      all: false,
      loading: false
    }
  },

  computed: {
    isOpen() {
      return this.$store.state.navbar.isCategoryLockOpen
    },
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    categories() {
      return this.$store.state.category.items
    },
    postData() {
      return this.categories.map(cat => ({
        category_id: cat.category_id,
        locked: this.checks.includes(cat.category_id),
        revision: cat.revision
      }))
    }
  },

  methods: {
    onAllToggle() {
      this.checks = this.all
        ? this.categories.map(c => c.category_id)
        : []
    },
    onToggle() {
      this.all = this.checks.length === this.categories.length
    },
    async save() {
      this.loading = true

      try {
        const response = await api.lock(this.businessId, this.postData)

        // カテゴリ一覧を更新
        const newCategories = this.getNewCategories(response.revision_list)
        this.$store.commit('category/SET_ITEMS', newCategories)

        this.$modal.show('category-lock-modal')
      } catch(err) {
        renderError(err)
      } finally {
        this.close()
        this.loading = false
      }
    },
    getNewCategories(revisionList) {
      return this.categories.map(cat => {
        const revisionItem = revisionList.find(
          r => r.unique_key * 1 === cat.category_id * 1
        )
        const revision = revisionItem ? revisionItem.revision : cat.revision
        const locked = this.checks.includes(cat.category_id)
        return Object.assign({}, cat, { revision, locked })
      })
    },
    close() {
      this.$store.commit('navbar/toggleCategoryLock')
    }
  },

  watch: {
    categories: {
      handler(val) {
        this.checks = val.filter(v => v.locked).map(v => v.category_id)
      },
      immediate: true
    },
    watch: {
      isOpen(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.scrollArea.scrollTop = 0
          })
        }
      }
    }
  }
}
</script>
